<template>
  <div class="box" id="box" :class="[hostClass, isPhone ? 'm' : '']">
    <i class="bg"></i>
    <iframe :src="supportUrl" id="support-page" class="support-page"></iframe>
  </div>
</template>

<script>
import { CHECK_IP_LOCATION } from '../../store/ipCheck';
import globalConfig from '../../utiles/globalConfig';
import { isPhone } from '../../utiles/device';
const mainHost = globalConfig.getMainHost();
export default {
  data() {
    let curSupportUrl = window.location.href
      .replace(/webSupport/, 'support')
      .replace(/#\//, '');
    if (globalConfig.isUidGame()) {
      let curGameId = globalConfig.getUidGameId(window.location.host);
      if (curGameId) {
        curSupportUrl += `${
          !!~curSupportUrl.indexOf('?') ? '&' : '?'
        }gameId=${curGameId}`;
      }
    }
    return {
      supportUrl: curSupportUrl,
      isPhone: isPhone(),
      hostClass: mainHost.replace(/.[^.]*$/, ''),
    };
  },
  beforeCreate() {
    // 泰越斗罗h5：泰国地区域名跳转
    if (mainHost === atob('c2xmdW50YXAuY29t')) {
      this.$store.dispatch(CHECK_IP_LOCATION).then(res => {
        if (res.ISO_TWO_CODE == 'TH') {
          window.location.href = window.location.href.replace(
            new RegExp(atob('c2xmdW50YXAuY29t')),
            atob('ZW5kb21haW5uYW1lLmNvbQ==')
          );
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/base.scss';
@import '../../assets/scss/webSupport.scss';
</style>
